import React from 'react';

const RhodeIsland = () => (
  <svg
    width="7"
    height="13"
    viewBox="0 0 7 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.42791 0.37207C5.44168 2.11117 5.61767 3.33628 4.94182 4.9768C5.82887 6.13855 6.17384 7.83541 5.96264 10.0955C4.80102 10.6447 3.70982 11.2573 2.89317 12.1444C2.47076 9.67308 1.15426 5.02609 0.330566 1.393C1.53442 0.893094 2.85092 0.498806 4.42791 0.37207Z"
      fill="#FC374D"
    />
  </svg>
);
export default RhodeIsland;
